import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  emoji?: string;
}
export function FAQItem({
  question,
  answer,
  emoji
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:border-[#27AE60] transition-colors" data-id="element-275">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full p-4 flex items-center justify-between text-left hover:bg-[#FAF9F6] transition-colors" data-id="element-276">
        <div className="flex items-center gap-3" data-id="element-277">
          {emoji && <span className="text-2xl" data-id="element-278">{emoji}</span>}
          <h3 className="text-base md:text-lg font-bold text-[#2C3E50]" data-id="element-279">
            {question}
          </h3>
        </div>
        <ChevronDownIcon className={`w-5 h-5 text-[#27AE60] flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-280" />
      </button>
      {isOpen && <div className="px-4 pb-4 pt-2 border-t border-gray-100" data-id="element-281">
          <p className="text-gray-700 leading-relaxed" data-id="element-282">{answer}</p>
        </div>}
    </div>;
}